import React, { useEffect, useState } from "react";
import { motion } from 'motion/react';
import useApi from "../../utils/useApi";

function CommonTreetructure(props) {

    const [groupedModuleSubmoduleMain, setGroupedModuleSubmoduleMain] = useState(null)
    const [queryMenu, setQueryMenu] = useState('')

    const [debouncedQueryMenu, setDebouncedQueryMenu] = useState('')

    const { rawDataFromAPI, typeOfTree, selectedProjectObject, transferType, deleteType, clientCompanyId, roleId, callMenuOfRoleAgain, callRefreshMethod, datagetAllMenuOfThisRole } = props


    console.log("datagetAllMenuOfThisRole in CommonTreestructure", datagetAllMenuOfThisRole)
    console.log("rawdata-->", rawDataFromAPI)
    console.log(`CommonTree--->${clientCompanyId} -- typeOfTree -- ${typeOfTree}`, rawDataFromAPI, typeOfTree, selectedProjectObject)



    const [filteredResult, setFilteredResult] = useState()

    const [currentSelectedMouleObject, setCurrentSelectedMouleObject] = useState()

    const [selectedMenuToTransfer, setSelectedMenuToTransfer] = useState(null)

    const { data: datapostTransferMenuToRole, loading: loadingpostTransferMenuToRole, error: errorpostTransferMenuToRole, post: postTransferMenuToRole } = useApi()
    const { data: datapostDeleteMenuFromRole, loading: loadingpostDeleteMenuFromRole, error: errorpostDeleteMenuFromRole, post: postDeleteMenuFromRole } = useApi()
    const { data: datapostAddMenuToClientCompany, loading: loadingpostAddMenuToClientCompany, error: errorpostAddMenuToClientCompany, post: postAddMenuToClientCompany } = useApi() // can be client or template company no problem only id changes rest similar
    const { data: datapostDeleteMenuToClientCompany, loading: loadingpostDeleteMenuToClientCompany, error: errorpostDeleteMenuToClientCompany, post: postDeleteMenuToClientCompany } = useApi() // can be client or template company no problem only id changes rest similar



    useEffect(() => {
        const handlerMenu = setTimeout(() => {
            setDebouncedQueryMenu(queryMenu.trim().toLowerCase());
        }, 500);

        return () => clearTimeout(handlerMenu);
    }, [queryMenu]);


    useEffect(() => {
        if (!debouncedQueryMenu) {
            setFilteredResult(groupedModuleSubmoduleMain);
            return;
        }

        if (!groupedModuleSubmoduleMain) {
            return;
        }

        const results = [];

        for (const module of groupedModuleSubmoduleMain) {
            const matchedSubmodules = [];

            for (const submodule of module.SUBMODULES) {
                const matchedMenus = submodule.MENUS.filter(menu =>
                    menu.MENUNAME.toLowerCase().includes(debouncedQueryMenu)
                );

                if (matchedMenus.length > 0) {
                    matchedSubmodules.push({
                        SUBMODULEID: submodule.SUBMODULEID,
                        SUBMODULENAME: submodule.SUBMODULENAME,
                        MENUS: matchedMenus
                    });
                }
            }

            if (matchedSubmodules.length > 0) {
                results.push({
                    MODULEID: module.MODULEID,
                    MODULENAME: module.MODULENAME,
                    ORDER: module.ORDER,
                    SUBMODULES: matchedSubmodules
                });
            }
        }

        setFilteredResult(results);
    }, [debouncedQueryMenu, groupedModuleSubmoduleMain]);

    const clickedOnMenuListItem = (menuItemObjectFromClick, subModuleId, moduleId, projectId, module_name, sub_module_name) => {


        console.log("menuItemObject clickedOn Client", menuItemObjectFromClick, subModuleId, moduleId, projectId)

        let menuItemObject = { ...menuItemObjectFromClick, SUBMODULEID: subModuleId, SUBMODULENAME: sub_module_name, MODULEID: moduleId, MODULENAME: module_name, PRODUCTID: projectId }

        let newArray = []

        if (selectedMenuToTransfer) {

            if (selectedMenuToTransfer?.filter((itemFilly) => itemFilly.MENUID === menuItemObject.MENUID)?.length > 0) {

                newArray = selectedMenuToTransfer?.filter((itemFilly) => itemFilly.MENUID != menuItemObject.MENUID)
            } else {
                newArray = [...selectedMenuToTransfer, menuItemObject]
            }

        } else {
            newArray = [menuItemObject]
        }

        setSelectedMenuToTransfer(newArray)
    }


    useEffect(() => {

        if (rawDataFromAPI && selectedProjectObject) {

            console.log("rawDataFromAPI filtering", selectedProjectObject, rawDataFromAPI, rawDataFromAPI?.filter((itemFilly) => itemFilly.PRODUCTID === selectedProjectObject?.PRODUCTID))


            const grouped = [];



            rawDataFromAPI?.filter((itemFilly) => itemFilly.PRODUCTID === selectedProjectObject?.PRODUCTID).forEach(item => {
                // Find or create module
                let module = grouped.find(m => m.MODULEID === item.MODULEID);
                if (!module) {
                    module = {
                        MODULEID: item.MODULEID,
                        MODULENAME: item.MODULENAME,
                        ORDER: item.ORDER,
                        SUBMODULES: []
                    };
                    grouped.push(module);
                }

                // Find or create submodule
                let submodule = module.SUBMODULES.find(sm => sm.SUBMODULEID === item.SUBMODULEID);
                if (!submodule) {
                    submodule = {
                        SUBMODULEID: item.SUBMODULEID,
                        SUBMODULENAME: item.SUBMODULENAME,
                        MENUS: []
                    };
                    module.SUBMODULES.push(submodule);
                }

                // Add menu to submodule
                submodule.MENUS.push({
                    MENUID: item.MENUID,
                    MENUNAME: item.MENUNAME,
                    IMAGEPATH: item.IMAGEPATH,
                    ORDER: item.ORDER
                });
            });

            console.log("json after grouping ", JSON.stringify(grouped, null, 2));


            setGroupedModuleSubmoduleMain(grouped)
            setFilteredResult(grouped)



            if (grouped?.length > 0) {
                setCurrentSelectedMouleObject(grouped[0])
            }


        }

    }, [rawDataFromAPI, selectedProjectObject])

    useEffect(() => {

        console.log("filtered result ", filteredResult)

    }, [filteredResult])


    const addMenuToRole = () => {


        console.log("selectedMenuToTransfer ", selectedMenuToTransfer)

        if (!clientCompanyId) {
            alert("No company selected")
            return
        }

        if (!roleId) {
            alert("No role selected")
            return
        }

        if (!selectedMenuToTransfer) {
            alert("No menu selected")
            return
        }

        const menuItems = selectedMenuToTransfer.map((menu) => ({
            CMPCODE: clientCompanyId,
            COMPID: clientCompanyId,
            ROLEID: roleId,
            PRODUCTID: selectedProjectObject.PRODUCTID,
            MODULEID: menu?.MODULEID,
            MODULENAME: menu?.MODULENAME,
            SUBMODULEID: menu.SUBMODULEID,
            SUBMODULENAME: menu.SUBMODULENAME,
            MENUID: menu.MENUID,
            MENUNAME: menu.MENUNAME,
            MODE: "ENTRY",
            IMAGEPATH: "/images/submodule/icon.png",
            ORDER: menu.ORDER,
        }));


        let serializedData = JSON.stringify(menuItems)

        console.log("menuItems to role", serializedData)




        postTransferMenuToRole('https://cubixweberp.com:213/api/crmmenumainclientrolereg', serializedData, {
            headers: {
                "Content-Type": "application/json",
            },
        })

    }

    const deleteMenusFromRole = () => {


        console.log("selectedMenuToTransfer deleteMenusFromRole", selectedMenuToTransfer)

        if (!clientCompanyId) {
            alert("No company selected")
            return
        }

        if (!roleId) {
            alert("No role selected")
            return
        }

        if (!selectedMenuToTransfer) {
            alert("No menu selected")
            return
        }

        const menuItems = selectedMenuToTransfer.map((menu) => ({
            CMPCODE: clientCompanyId,
            COMPID: clientCompanyId,
            ROLEID: roleId,
            PRODUCTID: selectedProjectObject.PRODUCTID,
            MODULEID: menu?.MODULEID,
            MODULENAME: menu?.MODULENAME,
            SUBMODULEID: menu.SUBMODULEID,
            SUBMODULENAME: menu.SUBMODULENAME,
            MENUID: menu.MENUID,
            MENUNAME: menu.MENUNAME,
            MODE: "DELETE",
            IMAGEPATH: "/images/submodule/icon.png",
            ORDER: menu.ORDER,
        }));


        let serializedData = JSON.stringify(menuItems)

        console.log("menuItems to role", serializedData)




        postDeleteMenuFromRole('https://cubixweberp.com:213/api/crmmenumainclientrolereg', serializedData, {
            headers: {
                "Content-Type": "application/json",
            },
        })

    }





    useEffect(() => {

        if (datapostTransferMenuToRole) {
            console.log("datapostTransferMenuToRole")

            if (datapostTransferMenuToRole?.result?.trim()?.toUpperCase() === "SAVED") {
                alert("Transfereed menu to Role")

                if (callMenuOfRoleAgain) {

                    setSelectedMenuToTransfer(null)
                    callMenuOfRoleAgain()
                }
            }
        }
    }, [datapostTransferMenuToRole])


    useEffect(() => {

        if (datapostDeleteMenuFromRole) {
            console.log("datapostDeleteMenuFromRole")

            if (datapostDeleteMenuFromRole?.result?.trim()?.toUpperCase() === "SAVED") {
                alert("Deleted menu to Role")

                if (callMenuOfRoleAgain) {
                    callMenuOfRoleAgain()
                }
                setSelectedMenuToTransfer(null)

            }
        }
    }, [datapostDeleteMenuFromRole])


    useEffect(() => {


        if (datapostAddMenuToClientCompany) {
            console.log("datapostAddMenuToClientCompany")

            if (datapostAddMenuToClientCompany?.result?.trim()?.toUpperCase() === "SAVED") {
                alert("Successfully transferred menu")

                if (callRefreshMethod) {
                    callRefreshMethod()
                }

                setSelectedMenuToTransfer(null)

            }
        }

    }, [datapostAddMenuToClientCompany])

    useEffect(() => {


        if (datapostDeleteMenuToClientCompany) {
            console.log("datapostDeleteMenuToClientCompany")

            if (datapostDeleteMenuToClientCompany?.result?.trim()?.toUpperCase() === "SAVED") {
                alert("Successfully deleted menu")

                if (callRefreshMethod) {
                    callRefreshMethod()
                }

                setSelectedMenuToTransfer(null)

            }
        }

    }, [datapostDeleteMenuToClientCompany])




    const addMenuToClientCompany = () => {


        if (!selectedProjectObject?.PRODUCTID) {
            alert("Please select PRODUCT ")
        }

        console.log("line 1")


        if (clientCompanyId) {

        } else {
            alert("Please Select Client Company ")
            return

        }


        console.log("line 2")

        if (!selectedMenuToTransfer) {
            alert("No menu data found, please check if menus are selected")
            return
        }

        if (selectedMenuToTransfer?.length === 0) {
            alert("No menu selected, please select Menu ")
            return
        }



        console.log("line 3", selectedMenuToTransfer)

        let checkAllFieldsForEmpty = selectedMenuToTransfer.filter((item) => {

            if ((clientCompanyId === null || clientCompanyId === undefined) && (clientCompanyId === null || clientCompanyId === undefined)) {
                console.log("commpany issue")
                return true
            }

            if (item.PRODUCTID === null || item.PRODUCTID === undefined) {
                return true
            }


            if (item.MODULEID === null || item.MODULEID === undefined) {
                return true
            }

            if (item.SUBMODULEID === null || item.SUBMODULEID === undefined) {
                return true
            }

            if (item.MENUID === null || item.MENUID === undefined) {
                return true
            }

            if (item.MENUNAME === null || item.MENUNAME === undefined) {
                return true
            }

        })

        if (checkAllFieldsForEmpty?.length > 0) {

            alert("Please select all values like module submodule menu target company")
            return
        }

        let arrayToPass = selectedMenuToTransfer.map((item) => {
            return {
                CMPCODE: "CUBOT",
                COMPID: clientCompanyId,
                PRODUCTID: item.PRODUCTID,
                MODULEID: item.MODULEID,
                MODULENAME: item.MODULENAME,
                SUBMODULEID: item.SUBMODULEID,
                SUBMODULENAME: item.SUBMODULENAME,
                MENUID: item.MENUID,
                MENUNAME: item.MENUNAME,
                MODE: "ENTRY",
                IMAGEPATH: "",
                ORDER: 1
            }
        })



        let serialized = JSON.stringify(arrayToPass)

        console.log("serialized addMenuToTemplateCompany--", serialized)


        postAddMenuToClientCompany(`https://cubixweberp.com:213/api/CRMMenuMainClientReg`, serialized, {
            headers: {
                "Content-Type": "application/json",
            },
        })
    }

    const deleteMenuInClientCompany = () => {


        if (!selectedProjectObject?.PRODUCTID) {
            alert("Please select PRODUCT ")
        }

        console.log("line 1")


        if (clientCompanyId) {

        } else {
            alert("Please Select Client Company ")
            return

        }


        console.log("line 2")

        if (!selectedMenuToTransfer) {
            alert("No menu data found, please check if menus are selected")
            return
        }

        if (selectedMenuToTransfer?.length === 0) {
            alert("No menu selected, please select Menu ")
            return
        }



        console.log("line 3", selectedMenuToTransfer)

        let checkAllFieldsForEmpty = selectedMenuToTransfer.filter((item) => {

            if ((clientCompanyId === null || clientCompanyId === undefined) && (clientCompanyId === null || clientCompanyId === undefined)) {
                console.log("commpany issue")
                return true
            }

            if (item.PRODUCTID === null || item.PRODUCTID === undefined) {
                return true
            }


            if (item.MODULEID === null || item.MODULEID === undefined) {
                return true
            }

            if (item.SUBMODULEID === null || item.SUBMODULEID === undefined) {
                return true
            }

            if (item.MENUID === null || item.MENUID === undefined) {
                return true
            }

            if (item.MENUNAME === null || item.MENUNAME === undefined) {
                return true
            }

        })

        if (checkAllFieldsForEmpty?.length > 0) {

            alert("Please select all values like module submodule menu target company")
            return
        }

        let arrayToPass = selectedMenuToTransfer.map((item) => {
            return {
                CMPCODE: "CUBOT",
                COMPID: clientCompanyId,
                PRODUCTID: item.PRODUCTID,
                MODULEID: item.MODULEID,
                MODULENAME: item.MODULENAME,
                SUBMODULEID: item.SUBMODULEID,
                SUBMODULENAME: item.SUBMODULENAME,
                MENUID: item.MENUID,
                MENUNAME: item.MENUNAME,
                MODE: "DELETE",
                IMAGEPATH: "",
                ORDER: 1
            }
        })



        let serialized = JSON.stringify(arrayToPass)

        console.log("serialized addMenuToTemplateCompany--", serialized)


        postDeleteMenuToClientCompany(`https://cubixweberp.com:213/api/CRMMenuMainClientReg`, serialized, {
            headers: {
                "Content-Type": "application/json",
            },
        })
    }


    return (
        <div>
            {rawDataFromAPI?.length > 0 ?
                <div className='flex' style={{ height: "400px", marginTop: "10px", borderRadius: "10px" }}>

                    <div style={{ width: "100%" }}>

                        <h2 style={{ display: "flex", alignItems: "center" }}> <svg className='w-10 me-1' xmlns="http://www.w3.org/2000/svg" class="w-10 h-10 text-gray-700" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M4 3a1 1 0 00-1 1v13h2v-2a1 1 0 011-1h2a1 1 0 011 1v2h2v-2a1 1 0 011-1h2a1 1 0 011 1v2h2V4a1 1 0 00-1-1H4zm3 4a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2zM7 9a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2zM7 12a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
                        </svg>
                            {typeOfTree} {typeOfTree === "Role And Menus" && roleId && <span> - {roleId}</span>}
                        </h2>

                        <div className='flex' style={{ width: "100%" }}>

                            <div style={{ padding: "10px", height: "300px", overflowY: "scroll", width: "20%", backgroundColor: "#f7f7f7", }}>
                                <h2 className="text-xl font-semibold mb-4 flex items-center">
                                    <svg
                                        className='me-2'
                                        fill="#1990a7"
                                        height="40px"
                                        width="40px"
                                        version="1.1"
                                        id="Capa_1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 232.971 232.971"
                                        xmlSpace="preserve"
                                    >
                                        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                        <g id="SVGRepo_iconCarrier">
                                            <path d="M232.971,116.485l-36.937-64h-56.939l-28.278-49H36.935L0,67.485l28.278,49L0,165.485l36.935,64h73.883l28.278-49h56.939 L232.971,116.485z M54.259,33.485h39.234l19.622,34l-19.622,34H54.259l-19.622-34L54.259,33.485z M93.493,199.485H54.259l-19.622-34 l19.622-34h39.234l19.622,34L93.493,199.485z M139.477,150.485l-19.622-34l19.622-34h39.233l19.622,34l-19.622,34H139.477z" />
                                        </g>
                                    </svg>

                                    Module List </h2>
                                <ul className="flex flex-col">
                                    <div>
                                        {filteredResult?.map((item) => (
                                            <li
                                                key={item.MODULEID}
                                                className="flex items-center p-1 w-full mb-4 shadow"
                                                onClick={() => { setCurrentSelectedMouleObject(item) }
                                                }

                                                style={{ padding: "10px", backgroundColor: "#f8f8f8" }}
                                            >

                                                <div>
                                                    {console.log("item side list module", item)}
                                                    <span className="text-xs" style={{ color: "#000000" }}>{item.MODULENAME}</span>
                                                   <div style={{display:"flex"}}>  <span className="text-xs">ORDER</span> <input style={{marginLeft:"10px", width:"30px", borderWidth:"1px", padding:"2px"}} value={item.ORDER} /> </div>
                                                </div>

                                            </li>
                                        ))}
                                    </div>

                                </ul>
                            </div>

                            <div style={{
                                width: "80%", height: "300px", backgroundColor: "#f7f7f7", marginLeft: "10px", borderRadius: "10px", padding: "1px", display: "flex",
                                flexDirection: "column"
                            }}>

                                <div className='shadow' style={{
                                    display: "flex", justifyContent: "space-between", backgroundColor: "#ffffff", padding: "12px", borderTopLeftRadius: "12px",
                                    borderTopRightRadius: "12px",
                                }}>
                                    <h2 className='p-2'>{currentSelectedMouleObject?.MODULENAME}</h2>
                                    <div style={{ display: "flex", justifyContent: "center", position: "relative" }}>

                                        <input
                                            type="text"
                                            placeholder="Search menus..."
                                            value={queryMenu}
                                            onChange={(e) => setQueryMenu(e.target.value)}
                                            style={{ padding: '8px', width: '300px', backgroundColor: "#f7f7f7", borderWidth: "1px", borderRadius: "5px", alignItems: "center" }}
                                        />
                                        {
                                            filteredResult?.length > 0 && queryMenu?.length > 0 &&
                                            <div className="absolute top-10 w-full mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5" >

                                                <p style={{ fontSize: "15px", color: "#949393", padding: "8px", fontWeight: "300" }}>Menu Found inside this modules</p>
                                                {
                                                    filteredResult.map((item) => {
                                                        return (
                                                            <p onClick={() => { setCurrentSelectedMouleObject(item); setQueryMenu('') }} style={{ display: "flex" }} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                    <path d="M10 0 V10 H20" stroke="#9CA3AF" strokeWidth="2" />
                                                                </svg>
                                                                <span className='ms-1'>{item.MODULEID}</span>
                                                            </p>
                                                        )
                                                    })
                                                }
                                            </div>
                                        }

                                    </div>
                                </div>



                                <div style={{ flexGrow: 1, overflowY: "scroll", padding: "10px" }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 ">
                                    {(() => {
                                        if (!currentSelectedMouleObject) return null;

                                        // If there's a search term, find the selected module in filteredResult (which only contains matching menus)
                                        const dataSource = debouncedQueryMenu
                                            ? filteredResult?.find(m => m.MODULEID === currentSelectedMouleObject.MODULEID)
                                            : currentSelectedMouleObject;

                                        if (!dataSource?.SUBMODULES?.length) {
                                            return (
                                                <div className="text-center text-gray-500 p-4">
                                                    No menus found.
                                                </div>
                                            );
                                        }

                                        return dataSource.SUBMODULES.map((submodule, index) => (
                                            <motion.div
                                                key={submodule.SUBMODULEID}
                                                initial={{ opacity: 0, y: 30 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                            >
                                                <div className="group hover:shadow-lg hover:bg-white transition-all duration-300 border-border/50 bg-card/50 backdrop-blur-sm p-4">
                                                    <div className="pb-3">
                                                        <div className="flex items-center">
                                                            <h5 style={{ fontWeight: "600" }} className="text-lg">
                                                                {submodule.SUBMODULENAME}
                                                            </h5>
                                                        </div>
                                                    </div>

                                                    <div className="pt-0">
                                                        <div className="space-y-1">
                                                            {submodule.MENUS?.map((menu) => (
                                                                datagetAllMenuOfThisRole?.filter((itemFilly) => {
                                                                    return itemFilly.MENUID === menu.MENUID
                                                                })[0] ?
                                                                    <div
                                                                        key={menu.MENUID}
                                                                        className="flex items-center cursor-pointer"
                                                                    >
                                                                        <svg width="20" height="20" viewBox="0 0 36 36" fill="#dedede">
                                                                            <path d="M36 32a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4v28z" />
                                                                            <path fill="#FFF" d="M29.28 6.362a2.502 2.502 0 0 0-3.458.736L14.936 23.877l-5.029-4.65a2.5 2.5 0 1 0-3.394 3.671l7.209 6.666c.48.445 1.09.665 1.696.665c.673 0 1.534-.282 2.099-1.139c.332-.506 12.5-19.27 12.5-19.27a2.5 2.5 0 0 0-.737-3.458z" />
                                                                        </svg>
                                                                        <span className="ms-2 text-sm text-muted-foreground group-hover/item:text-foreground transition-colors">
                                                                            {menu.MENUNAME}
                                                                        </span>
                                                                    </div>
                                                                    :


                                                                    <div
                                                                        key={menu.MENUID}
                                                                        onClick={() =>
                                                                            clickedOnMenuListItem(
                                                                                menu,
                                                                                submodule.SUBMODULEID,
                                                                                dataSource.MODULEID,
                                                                                selectedProjectObject.PRODUCTID,
                                                                                dataSource.MODULENAME,
                                                                                submodule.SUBMODULENAME
                                                                            )
                                                                        }
                                                                        className="flex items-center cursor-pointer"
                                                                    >
                                                                        {selectedMenuToTransfer?.some(sel => sel.MENUID === menu.MENUID)
                                                                            ? (
                                                                                <svg width="20" height="20" viewBox="0 0 36 36" fill="#77B255">
                                                                                    <path d="M36 32a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4v28z" />
                                                                                    <path fill="#FFF" d="M29.28 6.362a2.502 2.502 0 0 0-3.458.736L14.936 23.877l-5.029-4.65a2.5 2.5 0 1 0-3.394 3.671l7.209 6.666c.48.445 1.09.665 1.696.665c.673 0 1.534-.282 2.099-1.139c.332-.506 12.5-19.27 12.5-19.27a2.5 2.5 0 0 0-.737-3.458z" />
                                                                                </svg>
                                                                            ) : (
                                                                                <svg width="20" height="20" fill="#000000" viewBox="0 0 24 24">
                                                                                    <path d="M22,2H4A1,1,0,0,0,3,3V21a1,1,0,0,0,1,1H22a1,1,0,0,0,1-1V3A1,1,0,0,0,22,2ZM21,20H5V4H21Z"></path>
                                                                                </svg>
                                                                            )
                                                                        }
                                                                        <span className="ms-2 text-sm text-muted-foreground group-hover/item:text-foreground transition-colors">
                                                                            {menu.MENUNAME}
                                                                        </span>
                                                                    </div>



                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </motion.div>
                                        ));
                                    })()}
                                </div>


                                <div className='shadow' style={{
                                    display: "flex", justifyContent: "end", backgroundColor: "#ffffff", padding: "12px", borderBottomLeftRadius: "12px",
                                    borderBottomRightRadius: "12px",
                                }}>


                                    {transferType && transferType === "transfer_menu_role" && <button className="bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 px-4 rounded shadow-md transition duration-300 flex items-center" onClick={() => addMenuToRole()}>Transfer Menu To {roleId ? roleId : ""} Role
                                        <svg style={{ marginLeft: "10px" }} width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff">
                                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                            <g id="SVGRepo_iconCarrier">
                                                <path d="M2 10H14V6.43484C14 6.26397 14.2004 6.17179 14.3302 6.28299L21 12L14.3302 17.717C14.2004 17.8282 14 17.736 14 17.5652V14H2" stroke="#ffffff" strokeWidth="2" />
                                            </g>
                                        </svg>

                                    </button>}

                                    {transferType && transferType === "transfer_menu_to_client_company_from_cubot" && <button className="bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 px-4 rounded shadow-md transition duration-300 flex items-center" onClick={() => addMenuToClientCompany()}>Transfer Menu To {clientCompanyId ? clientCompanyId : ""} Company
                                        <svg style={{ marginLeft: "10px" }} width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff">
                                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                            <g id="SVGRepo_iconCarrier">
                                                <path d="M2 10H14V6.43484C14 6.26397 14.2004 6.17179 14.3302 6.28299L21 12L14.3302 17.717C14.2004 17.8282 14 17.736 14 17.5652V14H2" stroke="#ffffff" strokeWidth="2" />
                                            </g>
                                        </svg>

                                    </button>}



                                    {deleteType === "delete_menu_from_role" && transferType != "transfer_menu_role" && transferType != "transfer_menu_to_client_company_from_cubot" && selectedMenuToTransfer && selectedMenuToTransfer.length > 0 &&
                                        <button onClick={() => deleteMenusFromRole()} className="mt-4 bg-red-600 text-white px-4 py-2 rounded hover:bg-red-900 disabled:opacity-50">Delete</button>
                                    }

                                    {(deleteType === "delete_menu_from_client_company" || deleteType === "delete_menu_from_template_company") && transferType != "transfer_menu_role" && transferType != "transfer_menu_to_client_company_from_cubot" && selectedMenuToTransfer && selectedMenuToTransfer.length > 0 &&
                                        <button onClick={() => deleteMenuInClientCompany()} className="mt-4 bg-red-600 text-white px-4 py-2 rounded hover:bg-red-900 disabled:opacity-50">Delete</button>
                                    }

                                </div>

                            </div >
                        </div>

                    </div>
                </div>
                :
                <div>
                    <p style={{fontSize:20}}>No menu found, Please add menu to role</p>
                </div>
            }

        </div>
    )
}

export default CommonTreetructure